import { TDrawEntry } from '@daymade/api-contracts';
import RoundedButton from 'components/RoundedButton';
import Subheading from 'components/Subheading';
import { extendClassName } from 'utils/common';

const winsText = (numOfPrizes: number, numOfTreats: number) => {
  const prizeText = numOfPrizes + ' prize' + (numOfPrizes > 1 ? 's' : '');
  const treatText = numOfTreats + ' treat' + (numOfTreats > 1 ? 's' : '');

  if (numOfPrizes > 0 && numOfTreats > 0) {
    return prizeText + ' and ' + treatText;
  }
  if (numOfPrizes > 0 && numOfTreats === 0) return prizeText;
  if (numOfTreats > 0 && numOfPrizes === 0) return treatText;
  return 'a prize';
};

interface CongratsSectionProps {
  additionalClassName: string;
  revealInProgress: unknown;
  prizeWins: unknown[];
  materialPrizeWins: TDrawEntry[];
  tokensWon: number;
}

export const CongratsSection = ({
  additionalClassName,
  revealInProgress,
  prizeWins,
  materialPrizeWins,
  tokensWon,
}: CongratsSectionProps) => {
  if (revealInProgress || prizeWins.length === 0) {
    return null;
  }

  const numOfTreats = materialPrizeWins.filter((pw) =>
    /^Treat\d+$/i.test(pw.prizeTierCode ? pw.prizeTierCode : ''),
  ).length;
  const numOfPrizes = materialPrizeWins.length - numOfTreats;

  return (
    <div
      className={extendClassName(
        'congratsSection fullWidth flexCentered',
        additionalClassName,
      )}
    >
      <Subheading>Congrats!</Subheading>

      {materialPrizeWins.length > 0 && (
        <>
          <p>
            You won <strong>{winsText(numOfPrizes, numOfTreats)}</strong> in
            this draw
          </p>
          <RoundedButton href="/my-wins">Go to My Wins</RoundedButton>
        </>
      )}

      {materialPrizeWins.length === 0 && tokensWon > 0 && (
        <>
          <p>
            You won{' '}
            <strong>
              {tokensWon} token{tokensWon > 1 ? 's' : ''}
            </strong>{' '}
            in this draw
          </p>
          <RoundedButton href="/token-town">Redeem now</RoundedButton>
        </>
      )}

      <style jsx>
        {`
          .congratsSection {
            margin: 1.5em 0;
          }

          :global(.congratsSection .roundedButton) {
            margin-top: 1em;
          }
        `}
      </style>
    </div>
  );
};
